import { Box, ListItem } from '@chakra-ui/react';
import { ListView } from 'components/molecules/ListView';
import { FC } from 'react';
import { useListStore } from '../../hooks';
import { CrawlerListHeader } from './CrawlerListHeader';
import { CrawlerListItem } from './CrawlerListItem';

type UseListStoreReturnType = ReturnType<typeof useListStore>;

type Props = {
  listItems: UseListStoreReturnType['crawlers'];
  handleOpenDetailModal: UseListStoreReturnType['onOpenModal'];
};

export const CrawlerListView: FC<Props> = ({
  listItems,
  handleOpenDetailModal,
}) => (
  <>
    <Box m="20px 0 0 0">
      <CrawlerListHeader />
    </Box>
    <ListView>
      {listItems.map((item) => (
        <ListItem key={item.id} listStyleType="none">
          <CrawlerListItem
            item={item}
            handleClickRow={() => handleOpenDetailModal(item)}
          />
        </ListItem>
      ))}
    </ListView>
  </>
);
